export default __webpack_public_path__ + "static/media/uriel-soberanes.b741f54e.jpg";